import React from 'react'
import Ingredient from '../components/Ingredient'

const Ingrednts = () => {
  return (
    <Ingredient/>
  )
}

export default Ingrednts